<header class="d-flex flex-column">
  <div class="row justify-content-between align-items-center">
    <div class="col-md-8 d-flex flex-column">
      <span class="Custom-Report">
      Employee Monitoring Results
      </span>
      <div class="mt-3 d-flex flex-column">
        <span class="title-2">
          REPORT GENERATED BY
        </span>
        <span class="title-3">
          {{userData?.fullName}}, {{userData?.jobTitle}}
        </span>
        <div>
          <span class="title-2">
            Generated on :
          </span>
          <span class="title-3">{{today | dateFormat}}</span>
        </div>
      </div>
    </div>
    <div class="col-md-4 d-flex justify-content-end align-items-center">
      <div class="Vector-40 m-0"></div>
      <div class="Applied-Particle">
        <img src="./assets/images/Group-Logo.svg">
      </div>
    </div>
  </div>
  <div class="row mt-5">
    <div class="col-md-5 company-information d-flex flex-column">
      <span class="title-1">
        Company Information
      </span>
      <span class="title-2">
        Organization Name :
      </span>
      <span class="title-3">
        {{userData?.companyName}}, {{organizationLevel?.name}}
      </span>
    </div>
    <div class="Vector-62"></div>
    <div class="col-md-5 company-information d-flex flex-column">
      <span class="title-1">
        Sample Information
      </span>
      <div>
      <span class="title-2">
        Sample number :
      </span>
      <span class="title-3">{{sensorAssignmentData?.sampleNumber}}</span>
      </div>
      <span></span>
      <div>
      <span class="title-2">
        Sampling date :
      </span>
      <span class="title-3">{{ formattedRange }}</span>
    </div>
    </div>
  </div>
  <hr class="thick-hr w-100">
</header>

